import React from 'react';
import { aboutImage, company } from '../data/site';
import { Reveal } from './Reveal';
import { ButtonLink } from './ui/Button';
export function About() {
  return <section id="about" aria-labelledby="about-heading" className="bg-white py-20 lg:py-28" data-id="element-12" data-mp="2ptbhwdi09xe6">
      <div className="mx-auto grid max-w-container items-center gap-12 px-5 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:px-8" data-id="element-13" data-mp="2yrwyw47tx4cu">
        <Reveal data-id="element-14" data-mp="33s1frvcng13l">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-cobalt-700" data-id="element-15" data-mp="33qgmsa5zgq7u">
            About CoPro Services
          </p>
          <h2 id="about-heading" className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-charcoal-900 sm:text-[2.75rem]" data-id="element-16" data-mp="38o00n8yrr0z9">
            Professional Service. Personal Attention.
          </h2>

          <p className="mt-7 text-lg leading-relaxed text-charcoal-600" data-id="element-17" data-mp="3mismep595dea">
            CoPro Services provides dependable commercial and industrial
            solutions throughout Orlando and Central Florida — and we believe
            professional service should still feel personal.
          </p>

          <div className="mt-6 border-l-2 border-cobalt-700 pl-5" data-id="element-18" data-mp="2gr2yi6i08t7z">
            <p className="text-base leading-relaxed text-charcoal-700" data-id="element-19" data-mp="2cq9a7c0nhcek">
              At CoPro Services, we combine professional execution with
              personalized attention. We understand that every property and
              every project has different requirements, which is why we take the
              time to understand your needs and provide practical solutions
              designed around your space, timeline and goals.
            </p>
          </div>

          <p className="mt-6 text-base leading-relaxed text-charcoal-600" data-id="element-20" data-mp="2vnagd05xxik3">
            From painting and cleaning to ongoing property support, our goal is
            simple: quality work, clear communication and dependable service
            from start to finish.
          </p>

          <div className="mt-9" data-id="element-21" data-mp="3jdenhhic80fu">
            <ButtonLink href="#services" variant="outline" size="lg" data-id="element-22" data-mp="65u0ap2lusk5">
              Explore Our Services
            </ButtonLink>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="relative" data-id="element-23" data-mp="b4f2uv5bxobr">
          <div className="overflow-hidden rounded-lg" data-id="element-24" data-mp="3tj60hrurbr1s">
            <img src={aboutImage} alt="CoPro Services supervisor reviewing commercial painting work with a crew member inside an Orlando office property" className="h-full w-full object-cover" loading="lazy" data-id="element-25" data-mp="3tinzkhx5gonj" />
          </div>
          <div className="mt-4 rounded-lg border border-charcoal-100 bg-charcoal-50 p-5 sm:absolute sm:-bottom-8 sm:left-6 sm:mt-0 sm:max-w-xs sm:border-charcoal-200 sm:bg-white sm:shadow-lg" data-id="element-26" data-mp="3ole9d01xs8yn">
            <p className="text-sm font-bold tracking-tight text-charcoal-900" data-id="element-27" data-mp="3em5kumpubmjo">
              {company.tagline}
            </p>
            <p className="mt-1.5 text-sm text-charcoal-500" data-id="element-28" data-mp="18quidre74bwo">
              {company.serviceArea}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}